import React, { Component } from "react";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";
import { APP_FUNCTIONS_URL, SERVER_URL, LIBPANEL_DHC_ADDRESS } from "../../utils/constants";
import "./LoginQRCode.css";

const QR_CODE_VALIDITY = 119; // seconds

class LoginQRCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionId: "",
      qrCodeUrl: "",
      loading: true,
      showReload: false,
      timeRemaining: QR_CODE_VALIDITY,
      intent: props.intent
    };

    // For polling
    this.pollInterval = null;
    this.countdownInterval = null;
    this.pollTimeout = null;
  }

  componentDidMount() {
    // Generate QR code on component mount
    this.generateQRCode();

    // Expose clearPolling to parent component
    if (this.props.clearPollingRef) {
      this.props.clearPollingRef(this.clearPolling);
    }
  }

  componentWillUnmount() {
    this.clearPolling();
  }

  // Setup polling for auth status - similar to LoginPIN
  setupPolling = (sessionId) => {
    // Clear any existing polling
    this.clearPolling();

    // Start polling for auth status
    this.pollInterval = setInterval(async () => {
      try {
        // Use the same endpoint as in LoginPIN
        const response = await fetch(`${SERVER_URL}/api/getDlockSessionStatus?sessionId=${sessionId}`);

        if (response.ok) {
          const data = await response.json();

          if (data.status === "APPROVED" || data.status === "REJECTED") {
            // Found a definitive status, stop polling
            this.clearPolling();

            // Add sessionId to data
            data.sessionId = sessionId;

            // Pass result to parent
            this.props.onAuthStatusChange(data);
          }
        }
      } catch (error) {
        console.error("Error checking auth status:", error);
      }
    }, 3000);

    // Countdown timer for progress bar
    this.countdownInterval = setInterval(() => {
      this.setState(prevState => ({
        timeRemaining: Math.max(0, prevState.timeRemaining - 1)
      }), () => {
        // If time is up, show reload button
        if (this.state.timeRemaining <= 0) {
          this.clearPolling();
          this.setState({ showReload: true });
        }
      });
    }, 1000);

    // Set timeout to show reload after validity period
    this.pollTimeout = setTimeout(() => {
      this.clearPolling();
      this.setState({ showReload: true });
    }, QR_CODE_VALIDITY * 1000);
  }

  // Method to clear all polling intervals and timeouts
  clearPolling = () => {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }

    if (this.pollTimeout) {
      clearTimeout(this.pollTimeout);
      this.pollTimeout = null;
    }
  }

  // Generate QR code and start polling
  generateQRCode = () => {
    // Clear any existing polling
    this.clearPolling();

    this.setState({
      loading: true,
      showReload: false,
      timeRemaining: QR_CODE_VALIDITY
    });

    const newSessionId = uuidv4();
    this.setState({ sessionId: newSessionId });

    // Generate QR code URL
    const partnerDHCAddress = LIBPANEL_DHC_ADDRESS;
    const webHookUrl = `${APP_FUNCTIONS_URL}/dLockAuthWebhook`;

    // Encode the QR data and build the URL
    const qrCodeUrl = `${SERVER_URL}/api/getDlockQRcodeImage?sessionId=${newSessionId}&intent=${this.state.intent}&partnerDHCAddress=${partnerDHCAddress}&webHookUrl=${encodeURIComponent(webHookUrl)}`;
    this.setState({
      qrCodeUrl: qrCodeUrl,
      loading: false
    });

    // Start polling for this session
    this.setupPolling(newSessionId);
  }

  render() {
    const { qrCodeUrl, loading, showReload, timeRemaining } = this.state;
    const progressPercent = (timeRemaining / QR_CODE_VALIDITY) * 100;

    return (
      <div className="login-view-qr">
        <div
          style={{
            width: "12vw",
            height: "12vw",
            backgroundColor: "#99A8F2",
            lineHeight: "20vw",
            color: "white",
            margin: "1.5em",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

          }}
        >
          {loading ? (
            <div>Loading QR code...</div>
          ) : showReload ? (
            <button
              onClick={this.generateQRCode}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative"
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="white"
                style={{ animation: "spin 2s linear infinite" }}
              >
                <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
              </svg>
              <div style={{
                color: "white",
                fontSize: "10px",
                fontWeight: "bold",
                textAlign: "center",
                position: "absolute",
                top: "10px"
              }}>
                Kliknij, aby odświeżyć kod.
              </div>
              <style >{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        `}</style>
            </button>
          ) : (
            <img
              src={qrCodeUrl}
              alt="Login QR Code"
              style={{ width: "100%", height: "100%" }}
            />
          )}
        </div>

        {/* Progress Bar */}
        {!loading && !showReload && (
          <div style={{
            width: "12vw",
            margin: "1.5em 1.5em",
            position: "relative",
          }}>
            <div style={{
              height: "4px",
              backgroundColor: "#E0E0E0",
              borderRadius: "2px",
              overflow: "hidden",
              position: "relative"
            }}>
              <div style={{
                height: "100%",
                width: `${progressPercent}%`,
                backgroundColor: progressPercent > QR_CODE_VALIDITY ? "#4CAF50" : progressPercent > 10 ? "#FFC107" : "#F44336",
                transition: "width 1s linear, background-color 1s ease",
                position: "absolute",
                left: 0,
                top: 0
              }}></div>
            </div>
            <div style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "0.8em",
              marginTop: "0.2em",
              color: "#666"
            }}>
              zostało {timeRemaining < 60 ? timeRemaining : "1 min " + (timeRemaining - 60)}s
            </div>
          </div>
        )}
      </div>
    );
  }
}

LoginQRCode.propTypes = {
  onAuthStatusChange: PropTypes.func.isRequired,
  clearPollingRef: PropTypes.func
};

export default LoginQRCode;